import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FlagService {
  private flagFromA$ = new BehaviorSubject<boolean>(false);
  flagFromA = this.flagFromA$.asObservable();
  sendFlagFromA(val: boolean) {
    this.flagFromA$.next(val);
  }

  private flagFromB$ = new BehaviorSubject<boolean>(false);
  flagFromB = this.flagFromB$.asObservable();
  sendFlagFromB(val: boolean) {
    this.flagFromB$.next(val);
  }
}
